<template>
  <div class="tools">
    <NavBar></NavBar>
    <main
      property="mainContentOfPage"
      class="container"
      typeof="WebPageElement"
    >
      <Breadcrumb></Breadcrumb>
      <section class="custom-section">
        <div class="columns">
          <div
            class="column is-four-fifths-desktop is-full-tablet is-full-mobile"
          >
            <h1 class="title is-2" v-if="$i18n.locale == 'en'">
              {{ widget.name }}
            </h1>
            <h1 class="title is-2" v-if="$i18n.locale == 'fr'">
              {{ widget.nameFr }}
            </h1>
          </div>
        </div>
        <div class="columns">
          <div class="column is-11-desktop is-full-tablet is-full-mobile">
            <div class="large-text" v-if="$i18n.locale == 'en'">
              {{ widget.description }}
            </div>
            <div class="large-text" v-if="$i18n.locale == 'fr'">
              {{ widget.descriptionFr }}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <div class="card-content widget-box-live">
              <component :is="widget.tag" :lang="this.lang"> </component>
            </div>
          </div>
        </div>
      </section>
    </main>
    <BaseFooter></BaseFooter>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import BaseFooter from "@/components/Footer.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import store from "@/store/store.js"; //include vuex store so we can access this from beforeRouteEnter

export default {
  name: "Tools",
  props: {
    lang: {
      type: String,
      default: "en"
    },
    //receives widget as a prop
    widget: {
      type: Object,
      required: true
    }
  },
  components: {
    NavBar,
    BaseFooter,
    Breadcrumb
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    //TODO: add progress bar
    store.dispatch("widget/fetchWidget", routeTo.params.id).then(() => {
      //TODO: end progress bar
      next();
    });
  },
  created() {
    if (this.$i18n.locale == "en") {
      document.title =
        this.$t("widget_details.title") + " - " + this.widget.name;
    } else {
      document.title =
        this.$t("widget_details.title") + " - " + this.widget.nameFr;
    }
  },
  updated() {
    if (this.$i18n.locale == "en") {
      document.title =
        this.$t("widget_details.title") + " - " + this.widget.name;
    } else {
      document.title =
        this.$t("widget_details.title") + " - " + this.widget.nameFr;
    }
  }
};
</script>

<style scoped lang="scss">
.example-image {
  margin-top: 2rem;
}
.widget-steps {
  margin-top: 2rem;
}
table,
th,
td {
  border: 1px solid black;
}
th,
td {
  padding: 15px;
  text-align: center;
}
.widget-box-live {
  min-height: 460px;
  justify-content: center;
  background: #fff;
  margin: 0 0px 0 0px;
  border-radius: 5px;
  padding: 40px 40px 50px 40px;
}
</style>
